import { jsx as _jsx } from "react/jsx-runtime";
const VARIANT_STYLES = {
    error: "border-rose-200 bg-rose-50 text-rose-700",
    info: "border-sky-200 bg-sky-50 text-sky-700",
};
export function AuthAlert({ variant, children, className = "" }) {
    return (_jsx("div", { className: `mt-4 rounded-md border px-3 py-2 text-sm ${VARIANT_STYLES[variant]} ${className}`, role: variant === "error" ? "alert" : "status", children: children }));
}
